import { useCallback, useEffect, useState } from 'react';
import { captureNetworkError } from 'growth-onboarding-reliability/utils/raven';
import { closeBanner } from 'onboarding-tours/util/banner';
import { ManualDetectedTaskComponents } from 'setup-guide-components/components/checklist/internal/ManualDetectedTaskComponents';
import { useTaskApi } from 'setup-guide-components/hooks/task';
import { getQueryParam } from '../utils/urls';
import { useHistory } from 'react-router-dom';
import { QUICK_INVITE_MODAL_PATH } from 'setup-guide-components/utils/urls';
import { quickInviteModal } from 'getting-started-shared-tasks/taskNames';
import { getTracker } from '../utils/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
const ManualDetectedTasksContainer = () => {
  const taskKey = getQueryParam('taskKey');
  const ManualDetectedTaskComponent = taskKey && ManualDetectedTaskComponents[taskKey];
  const tracker = getTracker();
  const history = useHistory();
  if (taskKey === quickInviteModal) {
    history.push(QUICK_INVITE_MODAL_PATH);
  }
  const {
    checkAndCompleteTask
  } = useTaskApi();
  const [shouldShowTaskComponent, setShouldShowTaskComponent] = useState(true);
  const closeTaskComponent = useCallback(() => {
    if (!taskKey) {
      return;
    }
    setShouldShowTaskComponent(false);
    checkAndCompleteTask(taskKey).catch(captureNetworkError);
    closeBanner();
  }, [checkAndCompleteTask, taskKey]);
  useEffect(() => {
    window.addEventListener('beforeunload', closeBanner);
  }, []);
  if (!shouldShowTaskComponent || !ManualDetectedTaskComponent) {
    return null;
  }
  return /*#__PURE__*/_jsx(ManualDetectedTaskComponent, {
    onClose: closeTaskComponent,
    tracker: tracker
  });
};
export default ManualDetectedTasksContainer;